import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Shield, ArrowRight } from "lucide-react";

export default function AdminBillingCardSaved() {
    const navigate = useNavigate();
    const [countdown, setCountdown] = useState(3);

    useEffect(() => {
        const t = setInterval(() => setCountdown((c) => c - 1), 1000);
        return () => clearInterval(t);
    }, []);

    useEffect(() => {
        if (countdown <= 0) navigate("/admin/billing");
    }, [countdown, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-ink px-6 pt-20 grain" data-testid="card-saved-page">
            <div className="max-w-lg w-full">
                <div className="bg-ink-surface border border-emerald-500/30 rounded-sm p-10 text-center" data-testid="card-saved-success">
                    <div className="relative inline-block mb-5">
                        <Shield size={72} className="text-emerald-400" strokeWidth={1} />
                        <CheckCircle2 size={28} className="text-emerald-400 absolute -bottom-1 -right-1 bg-ink-surface rounded-full" strokeWidth={2} />
                    </div>
                    <h1 className="font-serif text-4xl text-white">Carta collegata</h1>
                    <p className="text-gray-400 mt-4 leading-relaxed">
                        La tua carta di credito è ora salvata in sicurezza su Stripe.
                        Sarà usata automaticamente al raggiungimento della soglia di fatturazione.
                    </p>
                    <div className="mt-6 inline-block px-4 py-2 bg-emerald-500/10 border border-emerald-500/30 rounded-sm text-emerald-400 text-xs uppercase tracking-widest">
                        Nessun addebito effettuato
                    </div>
                    <button
                        onClick={() => navigate("/admin/billing")}
                        className="mt-8 inline-flex items-center gap-2 bg-gold text-black font-semibold px-6 py-3 rounded-sm hover:bg-gold-light tracking-widest uppercase text-sm"
                        data-testid="back-to-billing-btn">
                        Torna alla fatturazione <ArrowRight size={14} />
                    </button>
                    <p className="text-[11px] text-gray-500 mt-4">
                        Reindirizzamento automatico in {Math.max(0, countdown)}s...
                    </p>
                </div>
            </div>
        </div>
    );
}
